const isDevelopment = process.env.NODE_ENV === 'development';

export const config = {
    API_BASE_URL: isDevelopment
        ? (process.env.REACT_APP_API_BASE_URL || 'https://localhost:6001')
        : (process.env.REACT_APP_API_BASE_URL || 'https://gw.hizliyo.com'),
    TIMEOUT: 30000,
    ENV: process.env.NODE_ENV || 'development',
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCLVW-O8CbNNVVYvJWbsC3L4w3tgypd0Og',
};

export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/api/Auth/login',
        REQUEST_CODE: '/api/Auth/request-login-code',
        RESEND_CODE: '/api/Auth/resend-code',
        VERIFY_CODE: '/api/Auth/verify-login-code',
        REFRESH_TOKEN: '/api/Auth/refresh-token',
        LOGOUT: '/api/Auth/logout',
        DELETE_ACCOUNT: '/api/Auth/delete-account',
    },

    FLEET_REGISTRATION: {
        REGISTER: '/api/fleet/register',
        LOOKUP_PROVINCES: '/api/fleet/lookup/provinces',
        LOOKUP_DISTRICTS: (provinceId) => `/api/fleet/lookup/provinces/${provinceId}/districts`,
        LOOKUP_SUBREGIONS: (districtId) => `/api/fleet/lookup/districts/${districtId}/subregions`,
    },

    LEGAL_AGREEMENT: {
        PENDING: '/api/FleetLegalAgreement/pending',
        BULK_ACCEPT: '/api/FleetLegalAgreement/bulk-accept',
        MY_ACCEPTANCES: '/api/FleetLegalAgreement/my-acceptances',
    },

    FLEET_READINESS: {
        CHECK: '/api/FleetReadiness',
    },

    FLEET_PANEL: {
        ME: '/api/fleet-panel/me',
        SCOPE_OPTIONS: '/api/fleet-panel/scope-options',
        SUPERVISORS_LIST: '/api/fleet-panel/supervisors/list',
        SUPERVISORS: '/api/fleet-panel/supervisors',
        SUPERVISOR_DETAIL: (supervisorId) => `/api/fleet-panel/supervisors/${supervisorId}`,
        SUPERVISOR_AREAS: (supervisorId) => `/api/fleet-panel/supervisors/${supervisorId}/areas`,
        SUPERVISOR_ACTIVE: (supervisorId, isActive) => `/api/fleet-panel/supervisors/${supervisorId}/active?isActive=${isActive}`,
        PROFILE: '/api/fleet-panel/profile',
        PROFILE_LOGO: '/api/fleet-panel/profile/logo',
        DASHBOARD: '/api/fleet-panel/dashboard',
        MEMBERS_LIST: '/api/fleet-panel/members/list',
        MEMBER_DETAIL: (memberId) => `/api/fleet-panel/members/${memberId}`,
        MEMBER_TERMINATE: (memberId) => `/api/fleet-panel/members/${memberId}/terminate`,
        MEMBER_ACTIVATE: (memberId) => `/api/fleet-panel/members/${memberId}/activate`,
        MEMBER_UPDATE_COURIER: (memberId) => `/api/fleet-panel/members/${memberId}/update-courier`,
        MEMBER_BUSY_STATUS: (memberId) => `/api/fleet-panel/members/${memberId}/busy-status`,
        MEMBER_SHIFTS: (memberId) => `/api/fleet-panel/members/${memberId}/shifts`,
        MEMBER_SHIFT_UPDATE: (memberId, scheduleId) => `/api/fleet-panel/members/${memberId}/shifts/${scheduleId}`,
        MEMBER_SHIFT_DELETE: (memberId, scheduleId) => `/api/fleet-panel/members/${memberId}/shifts/${scheduleId}`,
        MEMBER_STATISTICS: (memberId) => `/api/fleet-panel/members/${memberId}/statistics`,
        MEMBER_REGIONS: (memberId) => `/api/fleet-panel/members/${memberId}/regions`,
        MEMBER_REGION_DELETE: (memberId, regionId) => `/api/fleet-panel/members/${memberId}/regions/${regionId}`,
        COVERAGE_AREAS: '/api/fleet-panel/coverage-areas',
        JOIN_REQUESTS_LIST: '/api/fleet-panel/join-requests/list',
        JOIN_REQUEST_APPROVE: (requestId) => `/api/fleet-panel/join-requests/${requestId}/approve`,
        JOIN_REQUEST_REJECT: (requestId) => `/api/fleet-panel/join-requests/${requestId}/reject`,
        DELIVERIES_LIST: '/api/fleet-panel/deliveries/list',
        DELIVERY_DETAIL: (deliveryId) => `/api/fleet-panel/deliveries/${deliveryId}`,
        DELIVERY_TAB_COUNTS: '/api/fleet-panel/deliveries/tab-counts',
        // Restoran filtresi seçenekleri — sunucu yalnız filonun kendi restoranlarını döner.
        DELIVERY_PARTNERS: '/api/fleet-panel/deliveries/partners',
        DELIVERY_ASSIGN_COURIER: '/api/fleet-panel/deliveries/assign-courier',
        DELIVERY_ASSIGNMENT_SUGGESTIONS: (deliveryId) => `/api/fleet-panel/deliveries/${deliveryId}/assignment-suggestions`,
        DELIVERY_CRITICAL_SUMMARY: '/api/fleet-panel/deliveries/critical-summary',
        ROUTE_GEOMETRY: (fromLat, fromLng, toLat, toLng) =>
            `/api/fleet-panel/route-geometry?fromLat=${fromLat}&fromLng=${fromLng}&toLat=${toLat}&toLng=${toLng}`,
        // Filo iptal edemez — DELIVERY_CANCEL kaldırıldı.
        COURIER_LOCATIONS: '/api/fleet-panel/courier-locations',
        // Canlı harita işlemleri: kuryeden al / kurye adına yola çıkar / konum iste.
        DELIVERY_UNASSIGN_COURIER: (deliveryId) => `/api/fleet-panel/deliveries/${deliveryId}/unassign-courier`,
        DELIVERY_MARK_ON_THE_WAY: (deliveryId) => `/api/fleet-panel/deliveries/${deliveryId}/mark-on-the-way`,
        COURIER_LOCATION_REQUEST: (courierId) => `/api/fleet-panel/couriers/${courierId}/location-request`,
        // Canlı kurye takibi: tek çağrıda mesaideki kuryeler + mesaide olmayanlar + atanmamış paketler.
        LIVE_BOARD: '/api/fleet-panel/live-board',
        COURIER_ROUTES: (courierId) => `/api/fleet-panel/couriers/${courierId}/routes`,
        COURIER_SHIFT_START: (courierId) => `/api/fleet-panel/couriers/${courierId}/shift/start`,
        COURIER_SHIFT_END: (courierId) => `/api/fleet-panel/couriers/${courierId}/shift/end`,
        COURIER_DISPATCH_PAUSE: (courierId) => `/api/fleet-panel/couriers/${courierId}/dispatch-pause`,
        COST_HISTORY: '/api/fleet-panel/cost-history',
        COURIER_COST_HISTORY: '/api/fleet-panel/courier-cost-history',
        COURIER_COST_HISTORY_UPDATE: (id) => `/api/fleet-panel/courier-cost-history/${id}`,
        COURIER_COST_HISTORY_DELETE: (id) => `/api/fleet-panel/courier-cost-history/${id}`,
        EARNINGS_SUMMARY: '/api/fleet-panel/earnings/summary',
        EARNINGS_LIST: '/api/fleet-panel/earnings/list',
        COURIER_EARNINGS: '/api/fleet-panel/courier-earnings',
        FLEET_PAYMENTS_LIST: '/api/fleet-panel/fleet-payments/list',
        INVOICES_LIST: '/api/fleet-panel/invoices/list',
        INVOICE_DETAIL: (invoiceId) => `/api/fleet-panel/invoices/${invoiceId}`,
        FLEET_INVOICE_UPLOAD: '/api/fleet-panel/fleet-invoices/upload',
        FLEET_INVOICE_LIST: (fleetPaymentId) => `/api/fleet-panel/fleet-invoices/${fleetPaymentId}`,
        FLEET_PAYMENT_DELIVERIES: (fleetPaymentId) => `/api/fleet-panel/fleet-payments/${fleetPaymentId}/deliveries`,
        FLEET_PAYMENT_MODELS: (year, week) => `/api/fleet-panel/fleet-payments/models?year=${year}&week=${week}`,
        ISSUED_INVOICES: '/api/fleet-panel/issued-invoices',
        ISSUED_INVOICE_VIEWER_LINK: (invoiceId) => `/api/fleet-panel/issued-invoices/${invoiceId}/viewer-link`,
        PAYMENT_SUMMARY: '/api/fleet-panel/payment-summary',
        REPORTS: '/api/fleet-panel/reports',
        PLATFORM_LICENCES: '/api/fleet-panel/platform-licences',
        HEATMAP: '/api/fleet-panel/heatmap',
        BONUS_SETTINGS: '/api/fleet-panel/bonus-settings',
        WORKDAY_EARNINGS_LIST: '/api/fleet-panel/workday-earnings/list',

        // Yazılım bedeli: Hızlıyo'nun FİLOYA kestiği aylık fatura. Hakediş uçlarından
        // ayrı — orada filo alacaklı, burada borçlu.
        SOFTWARE_FEE_INVOICES: '/api/fleet-panel/software-fee/invoices',
        SOFTWARE_FEE_OBJECT: (invoiceId) => `/api/fleet-panel/software-fee/invoices/${invoiceId}/object`,

        // Yoğunlukta dış POS paket alımını duraklat/aç.
        INTEGRATION_INTAKE: (paused) => `/api/fleet-panel/integration-intake?paused=${paused ? 'true' : 'false'}`,

        // Entegratör mağazaları: onay bekleyenler ve karar ucu.
        VENDOR_STORES: (pendingOnly) => `/api/fleet-panel/vendor-stores?pendingOnly=${pendingOnly ? 'true' : 'false'}`,
        VENDOR_STORE_DECISION: (storeId, approved) =>
            `/api/fleet-panel/vendor-stores/${storeId}/decision?approved=${approved ? 'true' : 'false'}`,
    },

    COURIER_PAYMENT: {
        LIST: '/api/CourierPayment/admin/list',
        DETAIL: (paymentId) => `/api/CourierPayment/${paymentId}`,
    },

    NOTIFICATIONS: {
        LIST: (fleetId) => `/api/pushnotification/fleet/${fleetId}/notifications`,
        MARK_READ: (notificationId) => `/api/pushnotification/fleet/notification/${notificationId}/mark-as-read`,
    },

    PUSH: {
        WEBPUSH_CONFIG: '/api/pushnotification/webpush-config',
        REGISTER_DEVICE: '/api/pushnotification/register-device',
        UNREGISTER_DEVICE: '/api/pushnotification/unregister-device',
    },

    EMERGENCY: {
        LOGS: '/api/Courier/emergency-logs',
        FLEET_RESPOND: (logId) => `/api/Courier/emergency/${logId}/fleet-respond`,
    },

    COURIER_PAYMENTS: {
        LIST: (memberId) => `/api/fleet-panel/courier-payments/${memberId}/list`,
        APPROVE: (paymentId) => `/api/fleet-panel/courier-payments/${paymentId}/approve`,
        MARK_PAID: (paymentId) => `/api/fleet-panel/courier-payments/${paymentId}/mark-paid`,
    },

    STACKING_FEE_RULE: {
        LIST: '/api/fleet-panel/stacking-fee-rule/list',
        GET: (id) => `/api/fleet-panel/stacking-fee-rule/${id}`,
        CREATE: '/api/fleet-panel/stacking-fee-rule',
        UPDATE: (id) => `/api/fleet-panel/stacking-fee-rule/${id}`,
        DELETE: (id) => `/api/fleet-panel/stacking-fee-rule/${id}`,
    },
};

export const SIGNALR_HUBS = {
    FLEET: `${config.API_BASE_URL}/hubs/fleet`,
};

export const FLEET_HUB_METHODS = {
    REGISTER: 'Register',
    RECEIVE_FLEET_NOTIFICATION: 'ReceiveFleetNotification',
    RECEIVE_JOIN_REQUEST_NOTIFICATION: 'ReceiveJoinRequestNotification',
    RECEIVE_DELIVERY_UPDATE_NOTIFICATION: 'ReceiveDeliveryUpdateNotification',
    RECEIVE_FLEET_DISPATCH_NOTIFICATION: 'ReceiveFleetDispatchNotification',
    RECEIVE_MEMBER_UPDATE_NOTIFICATION: 'ReceiveMemberUpdateNotification',
    RECEIVE_COURIER_LOCATION_UPDATE: 'ReceiveCourierLocationUpdate',
};

/* Uygulama-içi (SignalR DIŞI) yayın olayları: bir ekranda yapılan işlem, aynı veriyi kendi
   sayısıyla gösteren diğer bileşenleri tazelesin. SignalR olayı yalnızca KARŞI taraftan gelen
   değişiklikte tetiklenir; kullanıcının kendi onayı/reddi hiçbir push üretmediği için sol menü
   rozeti eski sayıda kalıyordu. */
export const FLEET_APP_EVENTS = {
    JOIN_REQUESTS_CHANGED: 'fleet:join-requests-changed',
    /** Firma profili (ör. logo) değişti → sol menü ve kullanıcı rozeti tazelenir. */
    FLEET_PROFILE_CHANGED: 'fleet:profile-changed',
    /** Bu panelde bir pakete dokunuldu (atama/transfer) → sol menü sayacı tazelenir. */
    DELIVERIES_CHANGED: 'fleet:deliveries-changed',
};

export const emitFleetAppEvent = (eventName, detail) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const DispatchEventType = {
    OrderReceived: 1,
    CourierAssigned: 2,
    CourierNotFound: 3,
    CourierAccepted: 4,
    CourierRejected: 5,
    AssignmentExpired: 6,
    RegionMatchFailed: 7,
    ReassignmentStarted: 8,
    InsufficientBalance: 9,
    OrderDelivered: 10,
    PartnerNotReady: 11,
    FleetNotReady: 12,
    CourierNotReady: 13,
};

export const DeliveryStatus = {
    Pending: 0,
    Dispatching: 1,
    AwaitingCourierAcceptance: 2,
    Assigned: 3,
    PickingUp: 4,
    PickedUp: 5,
    Delivering: 6,
    Delivered: 7,
    Failed: 8,
    Cancelled: 9,
    PartnerPreparing: 10,
    InsufficientBalance: 11,
    KitchenReady: 12,
};

export const DeliveryStatusLabels = {
    0: 'Beklemede',
    1: 'Atama Yapılıyor',
    2: 'Kurye Onay Bekliyor',
    3: 'Atandı',
    4: 'Teslim Alınıyor',
    5: 'Teslim Alındı',
    6: 'Teslim Ediliyor',
    7: 'Teslim Edildi',
    8: 'Başarısız',
    9: 'İptal',
    10: 'Partner Hazırlanıyor',
    11: 'Yetersiz Bakiye',
    12: 'Hazır (Alınmayı Bekliyor)',
};

// Hakediş/fatura durumları backend `PaymentStatus` enum'undan gelir ve TEK yerde tanımlıdır:
// src/utils/paymentStatus.js. Buradaki eski 4 değerli kopya (0=PendingApproval …) enum
// 5 değere çıkınca kaymıştı ve ekranlarda yanlış etiket üretiyordu — kaldırıldı.

export const AccountDeleteReasonType = {
    Other: 0,
    NoLongerNeeded: 1,
    PrivacyConcerns: 2,
    TooManyNotifications: 3,
    BadExperience: 4,
    SwitchedToCompetitor: 5,
    TemporaryAccount: 6,
};

export const AccountDeleteReasonLabels = {
    0: 'Diğer',
    1: 'Artık ihtiyacım yok',
    2: 'Gizlilik endişeleri',
    3: 'Çok fazla bildirim alıyorum',
    4: 'Kötü deneyim yaşadım',
    5: 'Başka bir uygulamaya geçtim',
    6: 'Geçici hesaptı',
};
